import React from 'react';
import { useTheme } from '@components/theme';
import classNames from 'classnames';
import { FeaturedBoardsReference } from './model';
import styles from './Labels.module.scss';

export interface ILabels {
  featuredBoardsReference: FeaturedBoardsReference[];
  boardId: string;
  onHandleChangeBoard: (boardId: string) => void;
}

const Labels = ({
  featuredBoardsReference,
  boardId,
  onHandleChangeBoard
}: ILabels) => {
  const theme = useTheme();

  return (
    <div className={classNames(styles.BoardLabels, theme.styles.Overline)}>
      {featuredBoardsReference.map((featuredBoardRef) => {
        return (
          <div
            key={featuredBoardRef.label}
            role="button"
            tabIndex={0}
            onClick={() => onHandleChangeBoard(featuredBoardRef.boardId)}
            onKeyPress={(e) => {
              if (e.key === 'Enter') onHandleChangeBoard(featuredBoardRef.boardId);
            }}
            className={classNames(styles.Label, {
              [styles.LabelActive]: featuredBoardRef.boardId === boardId,
              [styles.LabelInactive]: featuredBoardRef.boardId !== boardId
            })}
          >
            {featuredBoardRef.label}
          </div>
        );
      })}
    </div>
  );
};

export default Labels;
